/* eslint-disable import/prefer-default-export */
import { ReportTypeEnum } from '@src/endpoints/services/reportmanager.service'

export const unknownTypeTitle = 'Unknown'

export const reportTypeTitles: { [key in ReportTypeEnum]: string } = {
  [ReportTypeEnum.REPORT_TYPE_UNUSED_ACCESS_ROLE_SUMMARY]: 'Unused Roles',
  [ReportTypeEnum.REPORT_TYPE_UNUSED_ACCESS_ROLE_BY_SERVICE_SUMMARY]:
    'Unused Roles by Service',
  [ReportTypeEnum.REPORT_TYPE_UNUSED_ACCESS_ROLE_BY_PRIVILEGE_SUMMARY]:
    'Unused Roles by Privilege',
  [ReportTypeEnum.REPORT_TYPE_UNUSED_ACCESS_IDENTITY_SUMMARY]:
    'Unused Identities w/ Role',
  [ReportTypeEnum.REPORT_TYPE_UNUSED_ACCESS_IDENTITY_BY_SERVICE_SUMMARY]:
    'Unused Identities w/ Role by Service',
  [ReportTypeEnum.REPORT_TYPE_UNUSED_ACCESS_IDENTITY_BY_PRIVILEGE_SUMMARY]:
    'Unused Identities w/ Role by Privilege',
  [ReportTypeEnum.REPORT_TYPE_UNUSED_ACCESS_IDENTITY_WITHOUT_ROLE_SUMMARY]:
    'Unused Identities w/o Role',
  [ReportTypeEnum.REPORT_TYPE_UNUSED_ACCESS_IDENTITY_WITHOUT_ROLE_BY_SERVICE_SUMMARY]:
    'Unused Identities w/o Role by Service',
  [ReportTypeEnum.REPORT_TYPE_UNUSED_ACCESS_IDENTITY_WITHOUT_ROLE_BY_PRIVILEGE_SUMMARY]:
    'Unused Identities w/o Role by Privilege',
  [ReportTypeEnum.REPORT_TYPE_UNKNOWN]: unknownTypeTitle
}
